import React, { Component } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import BidReceived from "./BidReceived";
import {setNullOffer, chargeAuctionWinPurchases,setAuctionServerUpdate,setDealsServerUpdate,setRaffleServerUpdate} from "../../actions/products";
import Routes from '../../routes';
import history from '../../history';




class HomeContainer extends Component {
  modalClose = () => {
    const {setNullOffer} = this.props;

    setNullOffer();
  };

  modalBidAgain = () => {
    const {productOffer, history} = this.props;

    this.modalClose();

    history.push(`${Routes.productPage}/${productOffer.type}/${productOffer.id}`);
  };

  render() {
    const { productOffer, auction, raffle, deals, purchases } = this.props;
    let products;
     
    if (!productOffer || !productOffer.id) {
      return (<Redirect to={Routes.main} />)
    }

    switch (productOffer.type) {
      case 'raffle':
        products = raffle;
        break;

      case 'deals':
        products = deals;
        break;

      case 'auction':
      default:
        products = auction;
    }
 console.log("BIDRECEIVEDPAGE productOffer:",productOffer);
      console.log("BIDRECEIVEDPAGE product:",products);
    return (
      <BidReceived
        purchases={purchases}
        products={products}
        productOffer={productOffer}
        modalClose={this.modalClose}
        modalBidAgain={this.modalBidAgain}
         chargeAuctionWinPurchases={chargeAuctionWinPurchases}
              setAuctionServerUpdate={setAuctionServerUpdate}
              setDealsServerUpdate={setDealsServerUpdate}
              setRaffleServerUpdate={setRaffleServerUpdate}
      />
    );
  }
}

const mapStateToProps = ({products}) => {
  return {
    auction: products.auction,
    raffle: products.raffle,
    deals: products.deals,
    productOffer: products.productOffer,
    purchases: products.purchases
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setNullOffer: () => {dispatch(setNullOffer())},
   setAuctionServerUpdate: (...props) => {dispatch(setAuctionServerUpdate(...props))},
        setDealsServerUpdate: (...props) => {dispatch(setDealsServerUpdate(...props))},
        setRaffleServerUpdate: (...props) => {dispatch(setRaffleServerUpdate(...props))}
  }
};





export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeContainer));